<form [formGroup]="contactForm" (ngSubmit)="onSubmit()" [hasUnsavedData]="contactForm">
  <button type="submit" hidden="hidden"></button>

  <div class="row mb-2">
    <div class="col-12 mr-auto">

      @if (!this.parentId) {
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <div class="d-inline-block">
                <div class="form-check d-inline-block me-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="isCompany"
                    id="individual"
                    formControlName="isCompany"
                    [value]="false"
                    checkFormFieldValidity
                    checked
                    />
                    <label
                      class="form-check-label"
                      for="individual"
                      translate
                      >
                      CONTACT_LBL_INDIVIDUAL
                    </label>
                  </div>
                  <div class="form-check d-inline-block ms-2 me-2">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isCompany"
                      id="company"
                      formControlName="isCompany"
                      checkFormFieldValidity
                      [value]="true"
                      />
                      <label
                        class="form-check-label"
                        for="company"
                        translate
                        >
                        CONTACT_LBL_COMPANY
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="row">
            <div [ngClass]="{'col-6': source == SourceEnum.Component, 'col': source == SourceEnum.Modal}">
              <div class="form-group">
                @if (this.isCompany()) {
                  <label
                    class="form-title-label"
                    translate
                    >CONTACT_LBL_NAME</label
                    >
                    <input
                      class="form-control form-title"
                      type="text"
                      formControlName="name"
                      [placeholder]="!this.isCompany() ? ('CONTACT_PLACEHOLDER_NAME_LASTNAME_FIRSTNAME' | translate) : ''"
                      checkFormFieldValidity
                      />
                    } @else {
                      <div class="row">
                        <div class="col-6">
                          <label
                            class="form-title-label"
                            for="lastname"
                            translate
                            >CONTACT_LBL_LASTNAME</label
                            >
                            <input
                              class="form-control form-title"
                              id="lastname"
                              name="lastname"
                              type="text"
                              formControlName="lastName"
                              oninput="this.value = this.value.toUpperCase()"
                              checkFormFieldValidity
                              />
                            </div>
                            <div class="col-6">
                              <label
                                class="form-title-label"
                                for="firstname"
                                translate
                                >CONTACT_LBL_FIRSTNAME</label
                                >
                                <input
                                  class="form-control form-title"
                                  id="firstname"
                                  name="firstname"
                                  type="text"
                                  formControlName="firstName"
                                  oninput="if (this.value) this.value = this.value[0].toUpperCase() + this.value.slice(1).toLowerCase()"
                                  checkFormFieldValidity
                                  />
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        @if (source == SourceEnum.Component) {
                          <div class="col-auto ms-auto">
                            <app-avatar-edit
                              [picturePath]="this.imageUrl"
                              [isCompany]="this.isCompany()"
                              (fileEmitter)="onAvatarChange($event)"/>
                            </div>
                          }
                        </div>
                        @if (source == SourceEnum.Component) {
                          <div class="row"
                            [style.display]="this.isCompany() ? 'none' : 'flex'">
                            <div class="col-6">
                              <div class="form-group row">
                                <div class="col">
                                  <app-typeahead
                                    [routeEndpoint]="'Contacts'"
                                    [entity]="Entity.Contact"
                                    [controlForm]="this.contactForm.controls['company']"
                                    [domain]="'name!=null,isCompany=true'"
                                    [orderBy]="'name asc'"
                                    [allowCustomActions]="false"
                                    [limitToList]="true"
                                    [placeholder]="'CONTACT_PLACEHOLDER_COMPANY' | translate"
                                  ></app-typeahead>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>

                    @let emailContactName = this.contactNameModel$ | async;
                    <div class="row">
                      <div class="col-12 col-md">
                        <div class="form-group row">
                          <label class="col-4 col-form-label-sm" translate
                            >CONTACT_LBL_EMAIL</label
                            >
                            <div class="col">
                              <input
                                class="form-control form-control-sm"
                                type="text"
                                [placeholder]="'CONTACT_PLACEHOLDER_EMAIL' | translate"
                                formControlName="email"
                                checkFormFieldValidity
                                />
                              </div>
                            </div>
                            @if (!!emailContactName) {
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                ></label>
                                <div class="col">
                                  <span class="ps-2">
                                    {{ 'CONTACT_MSG_EXISTING_CONTACT' | translate }}
                                    <app-link-to [id]="emailContactName.id.toString()"
                                      [label]="emailContactName.name"
                                      [url]="'/Contacts/Contacts/Details/'" />
                                    </span>
                                  </div>
                                </div>
                              }
                              <div class="form-group row">
                                <label class="col-4 col-form-label-sm" translate
                                  >CONTACT_LBL_PHONE_NUMBER</label
                                  >
                                  <div class="col">
                                    <input
                                      class="form-control form-control-sm"
                                      type="text"
                                      formControlName="phoneNumber"
                                      [placeholder]="'CONTACT_PLACEHOLDER_PHONE_NUMBER' | translate"
                                      mask="00 00 00 00 00"
                                      checkFormFieldValidity
                                      />
                                    </div>
                                  </div>

                                  <div class="form-group row">
                                    <label class="col-4 col-form-label-sm" translate
                                      >CONTACT_LBL_MOBILE_NUMBER</label
                                      >
                                      <div class="col">
                                        <input
                                          class="form-control form-control-sm"
                                          type="text"
                                          formControlName="mobilePhoneNumber"
                                          [placeholder]="'CONTACT_PLACEHOLDER_MOBILE_NUMBER' | translate"
                                          mask="00 00 00 00 00"
                                          checkFormFieldValidity
                                          />
                                        </div>
                                      </div>


                                      <div class="form-group row">
                                        @if (this.isCompany()) {
                                          <label class="col-4 col-form-label-sm" translate
                                            >CONTACT_LBL_TITLE_COMPANY</label
                                            >
                                          } @else {
                                            <label class="col-4 col-form-label-sm" translate
                                              >CONTACT_LBL_TITLE</label
                                              >
                                            }
                                            <div class="col">
                                              <app-typeahead
                                                [routeEndpoint]="'Titles'"
                                                [entity]="Entity.Title"
                                                [controlForm]="this.contactForm.controls['titleId']"
                                                [orderBy]="'id asc'"
                                                [limitToList]="true"
                                                [pageSize]="50"
                                                [placeholder]="this.isCompany() ? ('CONTACT_PLACEHOLDER_TITLE_COMPANY' | translate) : ('CONTACT_PLACEHOLDER_TITLE' | translate)"
                                                [domain]="this.titleDomain"
                                                [alwaysUseDomain]="true"
                                              ></app-typeahead>
                                            </div>
                                          </div>

                                          <div class="form-group row">
                                            <label class="col-4 col-form-label-sm" translate
                                              >CONTACT_LBL_PROFESSION</label
                                              >
                                              <div class="col">
                                                <input
                                                  class="form-control form-control-sm"
                                                  type="text"
                                                  [placeholder]="'CONTACT_PLACEHOLDER_PROFESSION' | translate"
                                                  formControlName="profession"
                                                  checkFormFieldValidity
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col">
                                              <!--      invisible-->
                                              <div class="form-group row collapse">
                                                <label class="col-4 col-form-label-sm" translate
                                                  >Empty</label
                                                  >
                                                  <div class="col">
                                                    <input
                                                      class="form-control form-control-sm"
                                                      type="text"
                                                      formControlName="empty"
                                                      checkFormFieldValidity
                                                      />
                                                    </div>
                                                  </div>
                                                  <app-address-edit [form]="this.contactForm.controls['contactAddress']"></app-address-edit>


                                                </div>
                                              </div>
                                              @if (source == SourceEnum.Component) {
                                                @if (!this.isEditMode) {
                                                  <app-contact-tabs-add-form [form]="this.contactForm"/>
                                                }
                                                @if (this.isEditMode) {
                                                  <app-contact-tabs-edit-form [form]="this.contactForm"/>
                                                }
                                              }
                                            </form>
